const fold = (text: string) => text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

/** Case- and diacritics-insensitive filter of a client-side search („kosice“ finds „Košice“). */
export function matchesQuery(query: string, ...texts: string[]) {
  const needle = fold(query.trim());
  return !needle || texts.some(text => fold(text).includes(needle));
}
